module.exports = __webpack_public_path__ + "static/img/background.6226d3b4.svg";